import { render } from "./TextArea.vue?vue&type=template&id=cd94651a"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=cd94651a&lang=css"
script.render = render

export default script